export const allClauseTypes = [
  { key: "clauseAir", value: "INSTITUTE CARGO CLAUSES (AIR)" },
  { key: "clauseA", value: "INSTITUTE CARGO CLAUSES (A)" },
  { key: "clauseB", value: "INSTITUTE CARGO CLAUSES (B)" },
  { key: "clauseC", value: "INSTITUTE CARGO CLAUSES (C)" },
  { key: "bulkOil", value: "INSTITUTE BULK OIL CLAUSES" },
  { key: "frozenFood", value: "INSTITUTE FROZEN FOOD CLAUSES" },
];
